import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import {
  Container, Grid, Box,
} from '@material-ui/core';
import BikeCard from 'common/components/bike_card/BikeCard';

const MotorcycleRentalSkeleton = (props) => {
  const { isShownSideMap } = props;

  return (
    <Container maxWidth="xl">
      <Box my={4}>
        <Skeleton variant="text" width="50%" height={60} />
        <Skeleton variant="text" width="70%" height={30} />
        <Skeleton variant="text" width="70%" height={30} />
      </Box>
      <Box my={3}>
        <Grid container spacing={3}>
          {[...Array(8).keys()].map((item) => (
            <Grid item lg={isShownSideMap ? 3 : 4} md={6} xs={12} key={item}>
              <BikeCard />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default MotorcycleRentalSkeleton;
